import React from 'react'
import {
  Bullet,
  Bullets,
  Info,
  Page,
  Section,
  Step,
} from '../../components/DocsComponents'
import DocLink from '../../components/DocLink'

const CleaningSchedules = () => (
  <Page
    title="Cleaning Schedules"
    intro="Cleaning schedules track when every vehicle is due its next deep clean, and record interim cleans, scheduled deep cleans, and decontaminations — including ATP testing."
  >
    <Section title="The cleaning dashboard">
      <Bullets>
        <Bullet>
          Open <DocLink url="/cleaning-schedules" text="Cleaning Schedules" />{' '}
          for counters of deep cleans due and overdue, and a per-vehicle
          breakdown of last deep clean dates and when the next one falls
          due, based on the deep clean frequency your organisation has set.
        </Bullet>
        <Bullet>
          Cleans marked exempt (vehicle unavailable or defective at the
          time) are tracked separately so KPI figures stay fair.
        </Bullet>
      </Bullets>
      <Info title="Who can do this?">
        The cleaning dashboard requires the <strong>Governance</strong>,{' '}
        <strong>Make Ready</strong>, or <strong>Fleet</strong> team (site
        administrators always). Deep clean frequency and the cleaning
        checklist are configured by the <strong>Make Ready</strong> team
        from Configuration.
      </Info>
    </Section>

    <Section title="Recording a clean">
      <Step number={1} title="Open the form">
        Go to <DocLink url="/vehicle-clean" text="Record Vehicle Clean" />,
        pick the vehicle, the start and end time, and the operative who did
        the clean. Any signed-in user can record a clean.
      </Step>
      <Step number={2} title="Pick the type of clean">
        Choose <strong>Interim</strong>, <strong>Deep (Scheduled)</strong>,
        or <strong>Decontamination</strong>. Decontaminations also need a
        reason recording. If the deep clean is overdue, the form shows the
        date it was due, with the option to mark the vehicle exempt from the
        KPI for that period.
      </Step>
      <Step number={3} title="ATP testing (deep and decontamination)">
        For anything other than an interim clean, record whether an ATP test
        was completed — the test type (Rapid Result or Luminometer) and the
        pass/fail result — or the reason it was not done.
      </Step>
      <Step number={4} title="Complete the checklist">
        Work through the cleaning checklist — the same checklist component
        used on the VDI form, configured by your organisation.
      </Step>
    </Section>

    <Section title="Clean reports">
      <p>
        Each recorded clean has a full report page, reachable from the
        cleaning section of the vehicle record. Viewing a clean report
        requires the <strong>Governance</strong>, <strong>Fleet</strong>, or{' '}
        <strong>Make Ready</strong> team.
      </p>
      <Info title="Decontamination Required status">
        A vehicle can be flagged <strong>Decontamination Required</strong>{' '}
        from the status chip on its record, so the whole team can see it
        needs a decontamination clean before going back into normal use.
      </Info>
    </Section>
  </Page>
)

export default CleaningSchedules
